import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import ParkDetails from "../components/MyCart/ParkDetails";
import ProductDetails from "../components/MyCart/ProductDetails";
import AddPromoCode from "../components/MyCart/AddPromoCode";
import GrandTotal from "../components/MyCart/GrandTotal";
import CartBanner from "../components/MyCart/BannerCart";
import MyCartFooter from "../components/MyCart/Footer";
import { Colors } from "../ColorConstants";
import { checkoutCart, getCart, updateCart } from "../services/cartServices";
import {
  checkIfGivenDateNotRestricted,
  getFormattedCart,
  getFormattedDate,
} from "../helper";
import {
  useNavigate,
  useSearchParams,
  useLocation,
  json,
} from "react-router-dom";
import { toast } from "react-toastify";
import Footer, { FooterMobile } from "../components/Footer";
import CheckoutPopup from "../components/MyCart/checkoutPopup";
import { updateGuest, updateGuestCart } from "../services/guestServices";
import ReactModal from "react-modal";
import Button from "../components/Buttons";
import CustomLoader from "../components/Loader";
import { BackArrow, BackButton } from "../assets/icons";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
import CartModal from "../components/MyCart/CartModal";
import ReactGA from "react-ga4";
import { PAYMENT_TYPE } from "../constants";
import ProductDetailsMobile from "../components/MyCart/ProductDetailsMobile";
import { Text } from "../TextConstants";
import AddPromoCodeMobile from "../components/MyCart/AddPromoCodeMobile";
import GrandTotalMobile from "../components/MyCart/GrandTotalMobile";
import { cartBg, LandingBgFail } from "../assets/images";
import PromoModal from "../components/MyCart/PromoModal";
import {
  fetchOutletDetails,
  fetchProductsOfParks,
} from "../services/parksServices";
import FreeTicketModal from "../components/MyCart/FreeTicketModal";
import { getSettings } from "../services/settingsService";
import PromoConfirmModal from "../components/MyCart/PromoConfirmModal";

const MyCart = () => {
  const [promo, setPromo] = useState("");
  const [hasPromo, setHasPromo] = useState("");
  const [cart, setCart] = useState({});
  const [outletDetails, setOutletDetails] = useState({});
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const [checkoutCustomModal, setCheckoutCustomModal] = useState(false);
  const [type, setType] = useState("");
  const [warningModal, setWarningModal] = useState(false);
  const [zeroAmtModal, setZeroAmtModal] = useState(false);
  const [insertId, setInsertId] = useState();
  const [isHavePromo, setIsHavePromo] = useState(true);
  const [isPlaceholder, setIsPlaceholder] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [isPromoModalOpen, setPromoModal] = useState(false);
  const [hasFreeTicket, setFreeTicket] = useState(false);
  const [freeTicketCount, setFreeTicketCount] = useState(0);
  const [products, setProducts] = useState([]);

  let [searchParams] = useSearchParams();
  let spinpromo = searchParams.get("spinpromo");
  let token = localStorage.getItem("token");
  let userType = localStorage.getItem("type");
  let guestSigned = localStorage.getItem("guestSigned");
  const [promoConfirmModal, setPromoConfirmModal] = useState(false);
  const location = useLocation();
  const date = location.state?.date;

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Cart Page" });
  }, []);

  const customStyles = {
    content: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      left: "0",
      top: 0,
      background: "transparent",
      border: "none",
      boxSizing: "border-box",
    },
    overlay: {
      background: Colors.blackOpacity,
      zIndex: 9999,
      display: "flex",
    },
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCart(spinpromo ? "applyCoupon" : "", true);
    if (spinpromo !== null) {
      setPromo(spinpromo);
    }
  }, [spinpromo]);

  useEffect(() => {
    const type = localStorage.getItem("type");
    if (type) {
      setType(type);
    }
  }, []);

  // const fetchSettings = async () => {

  // };

  const getSum = (array, key) => {
    let sum = 0;
    array?.forEach((item) => {
      if (item[key] !== undefined) {
        sum += item[key];
      }
    });
    return sum;
  };

  const getFreeTicketCount = (totalSum, details = []) => {
    if (!details?.length) return 0;

    let maxFreeQty = 0;

    for (const offer of details) {
      if (totalSum >= offer.minQty) {
        maxFreeQty = offer.freeQty;
      }
    }

    return maxFreeQty;
  };

  const isAtExactOfferPoint = (totalSum, details = []) => {
    return details.some((offer) => totalSum === offer.minQty);
  };

  // const totalSum =
  //   offerProducts?.length > 0
  //     ? offerProducts?.reduce((acc, key) => {
  //         return acc + getSum(cartProductQty, key) + getSum(newProductQty, key);
  //       }, 0)
  //     : 0;

  const fetchCart = async (from, showPopUp, productCode) => {
    console.log("date", date);
    setLoading(true);
    try {
      let res = await getCart(
        from === "deletePromo" ? "" : spinpromo || promo || ""
      );
      setCart(res?.data?.data);

      if (res?.data?.data?.outletShortName) {
        let outlet = await fetchOutletDetails(res?.data?.data?.outletShortName);
        setOutletDetails(outlet?.data?.data[0]);

        // let settings = await getSettings();
        let dynamicProducsts =
          outlet?.data?.data[0]?.dynamicPromotion?.products;
        let cartProuductQty = res?.data?.data?.items?.map((item) => ({
          [item?.productCode]: item.qty,
        }));
        const totalSum =
          dynamicProducsts.length > 0
            ? dynamicProducsts?.reduce((acc, key) => {
                return acc + getSum(cartProuductQty, key);
              }, 0)
            : 0;
        setFreeTicket(
          (showPopUp ||
            (outlet?.data?.data[0]?.dynamicPromotion?.products?.length > 0 &&
              outlet?.data?.data[0]?.dynamicPromotion?.products.includes(
                productCode
              ))) &&
            isAtExactOfferPoint(
              totalSum,
              outlet?.data?.data[0]?.dynamicPromotion?.details
            ) &&
            outlet?.data?.data[0]?.dynamicPromotion?.isEnabled &&
            checkIfGivenDateNotRestricted(
              outlet?.data?.data[0]?.dynamicPromotion?.restrictedDate,
              res?.data?.data?.bookingDate
            ) &&
            !res?.data?.data?.promo
        );
        setFreeTicketCount(
          getFreeTicketCount(
            totalSum,
            outlet?.data?.data[0]?.dynamicPromotion?.details
          )
        );

        // if (res?.data?.data?.outletShortName) {
        // setLWWDynamicPromo(settings?.data?.data?.lww_dynamic_promo);
        let products = await fetchProductsOfParks(
          res?.data?.data?.outletShortName,
          res?.data?.data?.bookingDate
        );

        let prodList = res?.data?.data?.items?.reduce((acc, v) => {
          acc[v.productId] = v.qty || 0;
          return acc;
        }, {});

        console.log(prodList);

        setProducts(
          products?.data?.data
            ?.filter((item) => item?.dontShowInCart)
            ?.map((v) => ({
              ...v,
              qty: prodList?.[v._id] || 0,
              date,
              productId: v._id,
            }))
        );
      }

      if (res?.data?.data?.items) {
        if (from === "applyCoupon") {
          if (res?.data?.data?.validPromo) {
            // toast.success("Promo applied successfully", {
            //   hideProgressBar: true,
            // });
            setPromoModal(true);
            setHasPromo(true);
            setIsPlaceholder(true);
            setIsRemove(true);
          } else {
            setIsPlaceholder(false);
            setIsRemove(false);
            toast.error("Invalid Promo", { hideProgressBar: true });
          }
        }
        setItems(res?.data?.data?.items);
      } else {
        navigate(`/auth/home`);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    let itemsArray = [...items];
    let itemsArrayClone = JSON.parse(JSON.stringify(items));
    let index = itemsArray.findIndex((x) => x._id === id);
    itemsArray.splice(index, 1);
    setItems(itemsArray);
    try {
      let res = await updateCart(getFormattedCart(cart, itemsArray));
      fetchCart("", false);
      console.log(res);
    } catch (err) {
      toast.error(err?.message);
      setItems(itemsArrayClone);
    }
  };
  const handleSubtract = async (id) => {
    let itemsArray = [...items];
    let itemsArrayClone = JSON.parse(JSON.stringify(items));
    let index = itemsArray.findIndex((x) => x._id === id);
    itemsArray[index].qty = itemsArray[index].qty - 1;
    if (itemsArray[index].qty === 0) {
      itemsArray.splice(index, 1);
    }
    setItems(itemsArray);
    try {
      let res = await updateCart(getFormattedCart(cart, itemsArray));
      fetchCart("", false, itemsArray[index]?.productCode);
      console.log(res);
    } catch (err) {
      toast.error(err?.message);
      setItems(itemsArrayClone);
    }
  };
  const handleAdd = async (id) => {
    let itemsArray = [...items];
    let itemsArrayClone = JSON.parse(JSON.stringify(items));
    let index = itemsArray.findIndex((x) => x._id === id);
    itemsArray[index].qty = itemsArray[index].qty + 1;

    // console.log(itemsArray[index].productCode.includes());

    setItems(itemsArray);

    try {
      let res = await updateCart(getFormattedCart(cart, itemsArray));
      fetchCart("", false, itemsArray[index].productCode);
    } catch (err) {
      toast.error(err?.message);
      setItems(itemsArrayClone);
    }
  };

  const handleApply = () => {
    if (
      (cart.discountAmount || 0) > 0 ||
      !!cart.dynamicProductPromo ||
      !!cart.dynamicPricePromo
    ) {
      setPromoConfirmModal(true);
    } else {
      fetchCart("applyCoupon", false);
    }
  };

  const handleApplyPromoCode = () => {
    fetchCart("applyCoupon", false);
    setPromoConfirmModal(false);
  };
  const handleRemove = async () => {
    setIsPlaceholder(false);
    try {
      setPromo("");
      fetchCart("deletePromo", false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCheckout = async (checkoutCustomModal) => {
    const isUAT =
      window.location.hostname.includes("uat") ||
      window.location.hostname.includes("localhost");
    let dependentProducts = items
      ?.filter((item) => item.isDependent)
      .map((item) => item.dependentProduct);
    let count = 0;
    dependentProducts.forEach((item) =>
      items?.filter((cartItem) => {
        console.log(cartItem?.productId, item);
        console.log();
        cartItem.productId === item && ++count;
      })
    );

    if (dependentProducts.length !== count) {
      setWarningModal(true);
    } else {
      if (!isUAT) {
        ReactGA.event({
          category: "Custom Events",
          action: `${cart?.outletName} checkout `,
          label: `${cart?.outletName} checkout of ${type}`,
        });
      }
      if (type === "guest") {
        if (guestSigned === "yes") {
          navigate(`/app/checkout?promo=${promo || spinpromo}`);
        } else {
          setCheckoutCustomModal(checkoutCustomModal);
        }
      } else {
        if (cart?.finalAmount === 0) {
          try {
            const obj = {
              type: "wallet",
            };
            let res = await checkoutCart(cart?._id, obj);
            setInsertId(res?.data?.data?.insertId);
            if (res?.data?.status === "success") {
              setZeroAmtModal(!zeroAmtModal);
            }
          } catch (err) {
            toast.error(err?.message, { hideProgressBar: true });
          }
        } else {
          if (hasPromo) {
            navigate(`/app/checkout?promo=${promo || spinpromo}`);
            if (!isUAT) {
              ReactGA.event({
                category: "Custom Events",
                action: `${promo || spinpromo} Promo used in ${
                  cart?.outletName
                } Checkout`,
                label: `${promo || spinpromo} Promo used in ${
                  cart?.outletName
                } Checkout of ${type}`,
              });
            }
          } else {
            navigate(`/app/checkout`);
          }
        }
      }
    }
  };

  const closeTicketModal = () => {
    setZeroAmtModal(false);
  };

  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      {
        label: "Booking",
        path:
          cart?.outletShortName === "aqua_zone"
            ? `/app/aqua`
            : `/app/booking/${cart?.outletId}`,
      },
      {
        label: cart?.outletName,
        path:
          cart?.outletShortName === "aqua_zone"
            ? `/app/aqua`
            : `/app/booking/${cart?.outletId}`,
      },
      { label: "Cart", path: `/app/cart` },
    ];
  };

  const handleGuestSubmit = async (data) => {
    try {
      let res = await updateGuest(data);

      await localStorage.setItem("token", res?.data?.data?.token);
      await localStorage.setItem("type", res?.data?.data?.type);
      await localStorage.setItem("guestSigned", "yes");
      if (cart?._id) {
        await updateGuestCart(cart?._id);
      }
      navigate(`/app/checkout?promo=${promo}`);
    } catch (err) {
      if (err?.code === 409) {
        localStorage.setItem("cartId", cart?._id);
        toast.warn("This email already exist, Please Sign In or Sign Up");
      } else {
        toast.error(err?.message);
      }
    }
  };

  const handleAddWristBandItem = async (bandItem) => {
    let selectedItems = [...products];

    selectedItems = selectedItems.map((item) => ({
      ...item,
      qty: item._id === bandItem._id ? item.qty + 1 : item.qty,
    }));

    let selectedItemsClone = JSON.parse(JSON.stringify(selectedItems));
    let nonZeroSelected = selectedItemsClone.filter((item) => item.qty > 0);
    setProducts(selectedItems);
    let itemsArray = [...items].filter((item) => !item.dontShowInCart);

    try {
      let res = await updateCart(
        getFormattedCart(cart, [...itemsArray, ...nonZeroSelected])
      );
      fetchCart("", false);
    } catch (err) {
      toast.error(err?.message);
    }
  };

  return (
    <>
      {/* {!spinpromo && (
        <BackImageContainer
          onClick={() => navigate(`/app/booking/${cart?.outletId}`)}
        >
          <BackImage src={BackButton} />
        </BackImageContainer>
      )} */}
      <BannerContainer>
        <img src={LandingBgFail} />
        <Overlay>
          <div>
            <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
          </div>
          {!checkoutCustomModal && (
            <div style={{ paddingTop: "1rem" }}>
              {["guest"].includes(userType) ? (
                <Button
                  onClick={() => navigate("/auth/login")}
                  label={"Sign In"}
                  variant="filled"
                  backgroundColor={Colors.white}
                  hoverColor={Colors.aqua}
                  hoverFontColor={Colors.white}
                  fontColor={Colors.aqua}
                  outlineColor={Colors.white}
                  borderRadius="2rem"
                />
              ) : (
                <Button
                  onClick={() => {
                    navigate("/auth/login");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    localStorage.removeItem("type");
                    localStorage.removeItem("name");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("guestSigned");
                  }}
                  label={"Sign Out"}
                  variant="filled"
                  backgroundColor={Colors.white}
                  hoverColor={Colors.aqua}
                  hoverFontColor={Colors.white}
                  fontColor={Colors.aqua}
                  outlineColor={Colors.white}
                  borderRadius="2rem"
                />
              )}
            </div>
          )}
        </Overlay>
      </BannerContainer>
      {checkoutCustomModal ? (
        <CheckoutPopup
          onClose={() => setCheckoutCustomModal(false)}
          onSubmit={handleGuestSubmit}
          cartId={cart?._id}
        />
      ) : (
        <CartContainer>
          <WebView checkoutCustomModal={checkoutCustomModal}>
            {/* <CartBanner /> */}
            {/* <BreadCrumb
              items={getBreadCrumbData()}
              activeItem={"Cart"}
              isButton={false}
            /> */}

            <ParkDetails data={cart} />
            <ProductDetails
              onAddWristBandItem={handleAddWristBandItem}
              products={products}
              hasSpinPromo={spinpromo}
              data={items}
              cartData={cart}
              onDelete={handleDelete}
              onSubtract={handleSubtract}
              onAdd={handleAdd}
              isAqua={cart?.outletShortName === "aqua_zone"}
              onContinueShopping={() =>
                cart?.outletShortName === "aqua_zone"
                  ? navigate(`/app/aqua`)
                  : navigate(`/app/booking/${cart?.outletId}`, {
                      state: { date: date },
                    })
              }
            />
            <ProductDetailsMobile
              data={items}
              onDelete={handleDelete}
              onSubtract={handleSubtract}
              onAdd={handleAdd}
              hasSpinPromo={spinpromo}
              isAqua={cart?.outletShortName === "aqua_zone"}
              onContinueShopping={() =>
                cart?.outletShortName === "aqua_zone"
                  ? navigate(`/app/aqua`)
                  : navigate(`/app/booking/${cart?.outletId}`, {
                      state: { date: date },
                    })
              }
            />
            <AddPromoCode
              onChange={(e) => setPromo(e.target.value)}
              value={promo}
              spinpromo={spinpromo}
              onApply={handleApply}
              cart={cart}
              userType={type}
              hasPromo={hasPromo}
              onContinueShopping={() =>
                navigate(`/app/booking/${cart?.outletId}`)
              }
              onRemove={() => {
                fetchCart("deletePromo", false);
              }}
            />
            <PromoCodeContainerMobile>
              {isHavePromo && spinpromo == null && (
                <IsPromoQuestion onClick={() => setIsHavePromo(false)}>
                  {Text.isPromoQuestion}
                </IsPromoQuestion>
              )}
              {(!isHavePromo || hasPromo) && (
                <AddPromoCodeMobile
                  onChange={(e) => setPromo(e.target.value)}
                  value={promo}
                  spinpromo={spinpromo}
                  onApply={handleApply}
                  isPlaceholder={isPlaceholder}
                  isRemove={isRemove}
                  setIsRemove={setIsRemove}
                  onRemove={handleRemove}
                  cart={cart}
                  userType={type}
                  onContinueShopping={() =>
                    navigate(`/app/booking/${cart?.outletId}`)
                  }
                />
              )}
              <GrandTotalMobile
                data={items}
                cart={cart}
                onCheckout={handleCheckout}
              />
            </PromoCodeContainerMobile>

            <PromoTotalContainer>
              <div
                style={{
                  width: "300px",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "2rem",
                }}
              >
                <img
                  style={{ width: "100%" }}
                  src={require("./../assets/images/lww_logo.png")}
                />
              </div>
              <GrandTotal
                data={items}
                cart={cart}
                onCheckout={handleCheckout}
              />
            </PromoTotalContainer>
            {/* <FooterContainer>
              <Footer />
            </FooterContainer>
            <FooterMobile /> */}
          </WebView>
          {loading ? <CustomLoader /> : <></>}
        </CartContainer>
      )}
      <ReactModal isOpen={warningModal} style={customStyles}>
        <WarningModal>
          <WarningModalHeader>Attention!</WarningModalHeader>
          <WarningModalDescription>
            Kids under 6 years must be accompanied by an adult
          </WarningModalDescription>
          <WarningModalAction>
            <Button
              onClick={() => setWarningModal(false)}
              variant="filled"
              label={"Ok, I Understand"}
              width="15rem"
            />
          </WarningModalAction>
        </WarningModal>
      </ReactModal>
      <CartModal
        isCancelTicket={zeroAmtModal}
        closeTicketModal={closeTicketModal}
        navigate={navigate}
        insertId={insertId}
      />
      <PromoModal
        promotionMsg={cart?.promotionMsg}
        savings={`${Text.qar} ${cart?.discountAmount}`}
        isPromoOpen={isPromoModalOpen}
        onClosePromoModal={() => setPromoModal(false)}
        promo={promo}
      />
      <FreeTicketModal
        count={freeTicketCount}
        isPromoOpen={hasFreeTicket}
        onClosePromoModal={() => setFreeTicket(false)}
      />
      <PromoConfirmModal
        onAddPromoCode={handleApplyPromoCode}
        isPromoOpen={promoConfirmModal}
        onClosePromoModal={() => setPromoConfirmModal(false)}
      />
    </>
  );
};
const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;

const WarningModal = styled.div`
  background: white;
  width: fit-content;
  padding: 2rem 1rem 1rem 1rem;
  border-radius: 0.5rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  @media only screen and (max-width: 640px) {
    width: 85%;
  }
`;
const WarningModalHeader = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
`;
const WarningModalDescription = styled.div``;
const WarningModalAction = styled.div`
  display: flex;
  justify-content: center;
`;

const CartContainer = styled.div`
  position: relative;

  @media only screen and (max-width: 640px) {
    height: 100vh;
    width: 100vw;
  }
`;
const WebView = styled.div`
  display: block;
  @media only screen and (max-width: 640px) {
    /* display:none; */
    display: ${(props) =>
      props.checkoutCustomModal === true ? "none" : "block"};
  }
`;

const PromoTotalContainer = styled.div`
  background: ${Colors.lightWhiteSmoke};
  display: flex;
  margin-top: 2rem;
  flex-direction: row;
  justify-content: space-around;
  padding: 0rem 1rem;
  gap: 1rem;
  @media only screen and (max-width: 640px) {
    flex-direction: column-reverse;
    align-items: center;
    justify-content: none;
    padding-bottom: 2rem;
    margin-top: 0rem;
  }
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const PromoCodeContainerMobile = styled.div`
  display: none;
  @media only screen and (max-width: 576px) {
    background: ${Colors.lightWhiteSmoke};
    display: flex;
    margin-top: 1.5rem;
    padding: 1.5rem 0;
    padding-bottom: 0;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
  }
`;
const IsPromoQuestion = styled.span`
  @media only screen and (max-width: 576px) {
    color: ${Colors.aqua};
    font-size: 1rem;
    font-weight: 700;
    width: 90%;
    padding-left: 1rem;
    // border: 1px solid red;
  }
`;
const PromoCodeTitle = styled.span`
  @media only screen and (max-width: 576px) {
    color: ${Colors.secondaryBlack};
    font-size: 1rem;
    font-weight: 700;
    width: 90%;
    // border: 1px solid red;
  }
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;
const BannerContainer = styled.div`
  height: 20rem;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  // @media only screen and (max-width: 1024px) {
  //   display: none;
  // }
`;
const Overlay = styled.div`
  position: absolute;
  // background-color: #0000005d;
  height: 10rem;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: start;

  top: 0;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;

const Logo = styled.img`
  width: 22rem;
  resize: contain;

  @media only screen and (max-width: 768px) {
    width: 14rem;
  }
`;

export default MyCart;
